import React from 'react';
import Navbar from '../../../@shared/navigations/default';
import { Options } from '../options';

const AccountChangePage = () => {
    return (
        <React.Fragment>
            <Navbar />
            <div id="account">
                <div className="container3">
                <div className="">
                    <div>
                        <ChangePassword />
                        <ChangeEmail />
                    </div>
                    <div>
                        <Options path='/account/change'  /> <br />
                    </div>
                </div>
                </div>
            </div>
        </React.Fragment>

    )
  }
  
export default AccountChangePage

  
export const ChangePassword = () => {

    return (
        <div className="create-page">
            <h3>Change Password</h3>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <label htmlFor="">Password</label>
                            <input type="password" name="password" placeholder="*****" />
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="form-group">
                            <label htmlFor="">Password</label>
                            <input type="password" name="confirm" placeholder="*****" />
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <label htmlFor="">Confirm</label>
                            <input type="password" name="confirm" placeholder="*****" />
                        </div>
                    </div>
                   
                </div>
            
                <div className="row">
                    <div className="col-12">
                        <button type="submit" className="float-right btn btn-primary button"  >Change</button>
                    </div>

                </div>
            </div>
    )
}

const ChangeEmail = () => {
    //  toast('🦄 Your password changed successfully!');
    return  (
            <div className="create-page">
                <h3>Change Email</h3>
                    <div className="row">
                    <div className="col-12">
                            <div className="form-group">
                                <label htmlFor="">Email</label>
                                <input type="email" name="email" placeholder=""  />
                            </div>
                        </div>

                    </div>
                
                    <div className="row">
                        <div className="col-12">
                            <button type="submit" className="float-right btn btn-primary button"  >Send confirmation code</button>
                        </div>

                    </div>
            </div>
     )
}
